import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import ContactForm from "@/components/form/ContactForm";
import {
  CalendarDateRangeIcon,
  CalendarIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { IconPhone } from "@tabler/icons-react";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import { Separator } from "@/components/ui/separator";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";
import { EnvelopeClosedIcon } from "@radix-ui/react-icons";
import { useTrackingFunctions } from "@/lib/meta/TrackingFunctions";

export default function ContactOptionsTabs({ className }) {
  const [isOpen, setIsOpen] = useState(true);

  const currentHour = new Date().getHours();
  const currentDay = new Date().getDay();

  const { trackContact, trackBeratungsterminStart } = useTrackingFunctions();

  useEffect(() => {
    if (
      currentHour >= 11 &&
      currentHour < 20 &&
      currentDay >= 1 &&
      currentDay <= 5
    ) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [currentDay, currentHour]);

  const tabData = [
    {
      id: "call",
      label: (
        <div className="flex gap-2 min-w-[7rem] w-full md:px-2">
          <PhoneIcon className="size-5" />
          <p className="parent:text-blue-500 ">Telefon</p>
        </div>
      ),
      content: (
        <div className="flex flex-col w-full items-start gap-10">
          <div>
            <h3 className="text-xl font-semibold text-dark-100 pb-5">
              Sie haben eine Frage?
            </h3>
            <p className="text- mb-5">
              Unsere Experten stehen Ihnen gerne telefonisch zur Verfügung und
              helfen weiter.
            </p>
            <Separator className="mb-8" />
            {isOpen ? (
              <a
                onClick={() => trackContact("phone", "")}
                href="tel:+49 2403 883170"
                className=""
              >
                <ButtonPrime
                  text="+49 2403 883170"
                  icon={<IconPhone className="stroke-[1px] inline" />}
                  className="px-6 py-2 bg-blue-500 text-white rounded-md font-light"
                ></ButtonPrime>
              </a>
            ) : (
              <BeratungsterminModal
                trigger={
                  <ButtonPrime
                    data-umami-event="kontakt_cta_rückruf_vereinbaren"
                    onClick={() => {
                      umami.track(`kontakt_cta_rückruf_vereinbaren`, "click");
                      trackBeratungsterminStart(
                        window.location.href,
                        "Rückruf"
                      );
                    }}
                    className="w-full"
                    text="Rückruf vereinbaren"
                    icon={
                      <IconPhone className=" stroke-prime-50 stroke-1 size-8" />
                    }
                  />
                }
              />
            )}
          </div>
          <div className="flex items-center gap-2">
            {isOpen ? (
              <div className="flex items-center gap-2">
                <div className="bg-lime-400 size-3 z-10 animate-pulse relative rounded-full "></div>

                <p className="text-lime-500">Jetzt verfügbar</p>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <div className="bg-red-500 size-3 rounded-full "></div>

                <p className="text-red-500">
                  Sie erreichen uns während unserer Servicezeiten
                </p>
              </div>
            )}
          </div>
          <div>
            <p className="text-gray-500">
              Telefonische Servicezeiten: <br /> Montag - Samstag <span></span>{" "}
              <br className="md:hidden" /> von 9:00 bis 20:00 Uhr{" "}
            </p>
          </div>
        </div>
      ),
    },
    {
      id: "contact",
      label: (
        <div className="flex gap-2 min-w-[7rem]  md:px-2">
          <EnvelopeClosedIcon className="size-5" />
          <p className=" ">Nachricht</p>
        </div>
      ),
      content: (
        <div className="flex flex-col justify-center md:w-full">
          <h3 className="font-sans text-lg text-left font-medium pb-7 pt-2">
            Leon Jakobs, Ihr Ansprechpartner
          </h3>
          <ContactForm
            button="Kontaktanfrage senden"
            fields={["name", "email", "phone", "agbAccepted", "message"]}
            className="w-full"
            toastText="Kontakt"
            event={() => trackContact("message", "")}
          />
        </div>
      ),
    },
    {
      id: "book",
      label: (
        <div className="flex gap-2 min-w-[7rem]  md:px-2">
          <CalendarIcon className="size-5" />
          <p className=" ">Termin</p>
        </div>
      ),
      content: (
        <div className="flex flex-col w-full items-start gap-10">
          <div>
            <h3 className="text-xl font-semibold text-dark-100 pb-5">
              Sie wollen beraten werden?{" "}
            </h3>
            <div className="text- mb-5">
              <p>
                {" "}
                Gerne beraten wir Sie kostenlos und unverbindlich zu Ihrer
                Immobilie.
              </p>
              <br />
              <p>
                Mit unserem Termintool können Sie direkt einen telefonische
                Erstberatung buchen.
              </p>
            </div>
            <Separator className="mb-8" />

            <BeratungsterminModal
              trigger={
                <ButtonPrime
                  data-umami-event="bewertungsseite_hero_vorort"
                  onClick={() => {
                    umami.track(
                      `kontakt_cta_beratungstermin_vereinbaren`,
                      "click"
                    );
                    trackBeratungsterminStart(window.location.href, "Termin");
                  }}
                  className="w-full"
                  text="Beratungstermin vereinbaren"
                  icon={
                    <CalendarDateRangeIcon className=" stroke-prime-50 stroke-1 size-8" />
                  }
                />
              }
            />
          </div>
        </div>
      ),
    },
  ];
  const [selectedTab, setSelectedTab] = useState(tabData[0].id);

  return (
    <div id="#ctasection" className={className}>
      <div className="">
        <div className="flex relative md:flex-row flex-col items-center justify-center py-5">
          <div>
            <img
              className="w-[35rem] rounded-md"
              src="/Fotos/landingpage-kontaktformular-jakobs.jpg"
              alt="Foto von Leon Jakobs in einem Anzug"
            />
          </div>

          <motion.div className="w-[95%]  max-w-[35rem] transition-all  mx-auto sm:mx-0 -translate-y-10 min-h-[30rem] md:min-h-[36.5rem] bg-white rounded-lg shadow-md px-4 py-8 md:-translate-x-10 md:translate-y-10">
            <LayoutGroup>
              {/* Tab button group */}
              <div className="absolute -top-10 left-0 right-0 mx-auto">
                <div className="relative font-sans flex overflow-x-auto scrollbar-none justify-start rounded-t-lg border-t border-gray-100 bg-gray-100 space-x-2  p-">
                  {tabData.map((tab) => (
                    <motion.button
                      key={tab.id}
                      onClick={() => setSelectedTab(tab.id)}
                      className="relative px-2 hover:bg-gray-50 rounded-lg py-4  font-medium focus:outline-none"
                      whileHover={{ scale: 1.01, color: "#e95c0c" }}
                    >
                      {/* Animated background for the selected tab */}
                      {selectedTab === tab.id && (
                        <div>
                          <motion.div
                            layout
                            layoutId="highlight"
                            transition={{
                              type: "spring",
                              stiffness: 300,
                              damping: 30,
                            }}
                            style={{ transformOrigin: "center" }}
                            className={`absolute inset-0  bg-white shadow- rounded-t-lg`}
                          />
                          {/* <motion.div
    layout
    layoutId="underline"
    transition={{ type: "spring", stiffness: 300, damping: 30 }}
    style={{ transformOrigin: "center" }}
    className={`absolute h-1 left-0 bottom-0 w-[120%] bg-prime-500 shadow- rounded-lg`}
  /> */}
                        </div>
                      )}

                      <span
                        className={
                          selectedTab === tab.id
                            ? "relative z-10 text-prime-700"
                            : "relative z-10"
                        }
                      >
                        {tab.label}
                      </span>
                    </motion.button>
                  ))}
                </div>
              </div>

              {/* Content area for the selected tab */}
              <div className=" overflow-hidden ">
                <AnimatePresence mode="wait">
                  {tabData.map(
                    (tab) =>
                      tab.id === selectedTab && (
                        <motion.div
                          key={tab.id}
                          initial={{ opacity: 0, x: 30 }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: -30 }}
                          transition={{ duration: 0.4 }}
                          className="mt-4 md:w-full  w-[80vw] max-w-[30rem] mx-auto"
                        >
                          {tab.content}
                        </motion.div>
                      )
                  )}
                </AnimatePresence>
              </div>
            </LayoutGroup>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
